import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { axios } from './request'
import { FIREBASE_PERMISSION_COUNT_KEY } from '../consts/push-notifications'

// Firebase configuration object

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_KEY,
    projectId: "api-project-886799817702",
    messagingSenderId: "886799817702",
    appId: "1:886799817702:web:9af638c01c12fa60b91427",
    measurementId: "G-LYZNVYQ5DV"
}

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)

// Initialize Firebase Messaging with defensive code to handle unsupported browsers
let messagingInstance = null;
let messagingInitialized = false;

const messaging = () => {
    // Return cached instance if already initialized
    if (messagingInitialized) {
        return messagingInstance;
    }

    messagingInitialized = true;

    try {
        if ('serviceWorker' in navigator) {
            messagingInstance = getMessaging(firebaseApp);
            return messagingInstance;
        } else {
            // Use debug instead of error since this is expected for unsupported browsers
            console.debug('Browser does not support serviceWorker');
            return null;
        }
    } catch (e) {
        console.error('Failed initiating messaging instance.', e);
        return null;
    }
};

// Request notification permission and get token
const requestPermission = async () => {
    try {
        const messagingInstance = messaging();
        if (!messagingInstance) {
            // Browser doesn't support serviceWorker or messaging failed to initialize
            console.debug('Messaging not available, skipping permission request');
            return null;
        }

        const permission = await Notification.requestPermission()

        if (permission === 'granted') {
            const token = await getToken(messagingInstance, {
                vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            })
            return token
        } else {
            console.debug(`Notification permission ${permission}`)
            incrementPermissionCount()
            return null
        }
    } catch (error) {
        console.debug(`Error requesting notification permission: ${error}`)
        incrementPermissionCount()
        return null
    }
}

// Send token to server
const sendTokenToServer = async (token) => {
    try {
        await axios.patch(
            process.env.REACT_APP_API_USERS_TOKENS,
            { firebase: token },
        )
    } catch (error) {
        console.debug(`Failed to send token to server: ${error}`)
    }
}

// Get permission request count from local storage
const getPermissionCount = () => {
    return parseInt(localStorage.getItem(FIREBASE_PERMISSION_COUNT_KEY) || '0', 10)
}

// Increment permission request count in local storage
const incrementPermissionCount = () => {
    const count = getPermissionCount()
    localStorage.setItem(FIREBASE_PERMISSION_COUNT_KEY, count + 1)
}

// Check and request notification permission
const checkAndRequestPermission = async () => {
    const permissionCount = getPermissionCount()
    if (permissionCount >= 3) {
        return
    }

    const token = await requestPermission()
    if (token) {
        await sendTokenToServer(token)
    }
}

// Add an abstracted listener for incoming messages
const onMessageListener = callback => {
    const messagingInstance = messaging();
    if (!messagingInstance) {
        // Browser doesn't support serviceWorker or messaging failed to initialize
        // Return early to avoid Firebase SDK errors
        console.debug('Messaging not available, skipping message listener setup');
        return;
    }
    try {
        onMessage(messagingInstance, callback);
    } catch (error) {
        console.debug('Failed to set up message listener:', error);
    }
};

export { checkAndRequestPermission, onMessageListener }